export default "__VITE_ASSET__DsbkDEdO__"